import { capitalize } from "../helpers/eliminarEs";
import { Fruit } from "../interfaces/interfaces";
import { UserSettings } from "../interfaces/interfaces.auth";
import { MainDataAllowed } from "./mainData";

export const batchData: MainDataAllowed = {
    pallet_ref: "",
    product: "",
    transport_document_1: "",
    transport_document_2: "",
    // product_temperature: 0,
    temperature: 0,
    origin: "",
    format: "",
    supplier: "",
    grower: "",
    gln: "",
    ggn: "",
    coc: "",
    variety: "",
    commercial_variety: "",
    type_of_punnet: "",
    type_of_cover: "",
    type_of_colli: "",
    type_of_label: "",
    total_boxes: 0,
    total_pallets: 0,
    total_colli: "",
    total_kilos: 0,
    quality: "",
    transport: "",
    purchase_order: "",
    delivery_note: "",
    warehouse: "",
    type_gps_tracker: "",
    tracker_number: "",
    samples: 0,
    format_gr: 0,
    // variety_ies: "",
}

export const basicBatchData: MainDataAllowed = {
    pallet_ref: "",
    supplier: "",
    product: "",
    format: "",
    grower: "",
    origin: "",
    client: "",
    total_kilos: 0,
    total_boxes: 0,
    total_pallets: 0,
    variety: "",
    quality: "",
    transport: "",
    format_gr: 0,
    loading_date: null,
    arrival_date: null,
}

export const basicBatchDataRepack = {
    pallet_ref: "",
    supplier: "",
    product: "",
    date: new Date(),
    format: "",
    staff_numbers: "1",
    repack_supervisor: "",
    warehouse: "",
    start_time: "",
    end_time: "",
}

export function pick<T extends object, K extends readonly (keyof T)[]>(
  obj: T,
  keys: K
): Pick<T, K[number]> {
  return Object.fromEntries(
    keys.map(key => [key, obj[key]])
  ) as Pick<T, K[number]>
}


export const batchDataProduct = (fruit: Fruit, settings: UserSettings | null): MainDataAllowed => {

    if (settings?.custom_fields.mainData) {
        const { pallet_ref, product, supplier, ...rest } = pick(basicBatchData, settings.custom_fields.mainData as (keyof MainDataAllowed)[])
        return {
            pallet_ref: "",
            supplier: "",
            product: capitalize(fruit),
            ...rest
        }
    }

    const { pallet_ref, product, supplier, ...rest } = basicBatchData

    return {
        pallet_ref: "",
        supplier: "",
        product: capitalize(fruit),
        ...rest
    }
};

export const batchDataRepack = (fruit: Fruit): MainDataAllowed => {
    const { pallet_ref, supplier, product, ...rest } = basicBatchDataRepack
    return {
        pallet_ref: "",
        supplier: "",
        product: capitalize(fruit),
        ...rest
    }
};

export const batchDataFast = (fruit: Fruit) => {
    return {
        pallet_ref: "",
        supplier: "",
        product: capitalize(fruit),
    }
};

export const allMainData: MainDataAllowed = {
    pallet_ref: "",
    extra_ref: "",
    supplier: "",
    product: "",
    format: "",
    grower: "",
    client: "",
    total_kilos: 0,
    total_boxes: 0,
    total_pallets: 0,
    transport_document_1: "",
    transport_document_2: "",
    // product_temperature: 0,
    temperature: 0,
    origin: "",
    gln: "",
    ggn: "",
    coc: "",
    gln_ggn_number: "",
    variety: "",
    unit_label: "",
    commercial_variety: "",
    type_of_punnet: "",
    type_of_cover: "",
    type_of_colli: "",
    type_of_label: "",
    total_colli: "",
    quality: "",
    transport: "",
    purchase_order: "",
    delivery_note: "",
    warehouse: "",
    type_gps_tracker: "",
    tracker_number: "",
    samples: 0,
    format_gr: 0,
    types_of_defects: "",
    discarded_fruit_kilos: 0,
    discarded_fruit_boxes: 0,
    loading_date: null,
    arrival_date: null,
    harvest_day: null,
}

export const units = [
    "MM",
    "Inch",
    "Gram",
    "Kilo",
    "Ounce",
    "Lb",
]

